import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environment';

import { LANGUAGES } from '@core/constants/language.constants';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private supportedLangs = [
    LANGUAGES.EN.toString(),
    LANGUAGES.DE.toString(),
    LANGUAGES.ES.toString(),
    LANGUAGES.FR.toString(),
    LANGUAGES.IT.toString(),
    LANGUAGES.PL.toString(),
    LANGUAGES.RO.toString(),
    LANGUAGES.CZ.toString(),
    LANGUAGES.NL.toString(),
    LANGUAGES.TR.toString(),
  ];

  private currentLanguage = LANGUAGES.EN.toString();

  constructor(
    private translateService: TranslateService,
    private appTitle: Title,
  ) {
    if (environment.development) {
      this.supportedLangs.push(LANGUAGES.ZZ.toString());
    }
  }

  setMemberLanguage(memberLang: string, companyDefaultLang: string): void {
    if (memberLang && this.supportedLangs.includes(memberLang)) {
      this.currentLanguage = memberLang;
    } else {
      const browserLang = this.translateService.getBrowserLang();
      if (browserLang && this.supportedLangs.includes(browserLang)) {
        this.currentLanguage = browserLang;
      } else if (
        companyDefaultLang &&
        this.supportedLangs.includes(companyDefaultLang)
      ) {
        this.currentLanguage = companyDefaultLang;
      }
    }

    this.setLanguage();
  }

  setLanguage(): void {
    this.translateService.addLangs(this.supportedLangs);
    this.translateService.setDefaultLang(
      environment.development ? LANGUAGES.ZZ : LANGUAGES.EN,
    );

    this.translateService
      .use(this.currentLanguage)
      .pipe(take(1))
      .subscribe(() =>
        this.appTitle.setTitle(this.translateService.instant('app.title')),
      );

    // @ts-ignore
    window.WEBSPELLCHECKER_CONFIG.localization = this.currentLanguage;
  }

  getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  getSupportedLanguages(): string[] {
    return this.supportedLangs;
  }
}
